const selectColorFacebook: {
  color: string;
  buttonColor: string;
}[] = [
  {
    color: "#99DCEE",
    buttonColor: "#7EA4D1",
  },
  {
    color: "#252D32",
    buttonColor: "#2892DD",
  },
  {
    color: "#3B5998",
    buttonColor: "#FFFFFF",
  },
  {
    color: "#348299",
    buttonColor: "#3C5664",
  },
  {
    color: "#00337C",
    buttonColor: "#00337C",
  },
  {
    color: "#B1D0E0",
    buttonColor: "#7C969D",
  },
];

export default selectColorFacebook;
